import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Declarative Mixpanel tracking via data attributes.
//
// Usage:
//   <button data-controller="analytics"
//           data-action="click->analytics#track"
//           data-analytics-event-value="Project Favorited"
//           data-analytics-props-value='{"project_id": 123}'>
//     Star
//   </button>
export default class extends Controller {
  static values = {
    event: String,
    props: { type: Object, default: {} }
  }

  track() {
    if (this.hasEventValue) {
      track(this.eventValue, this.propsValue)
    }
  }
}
